module.exports = __webpack_public_path__ + "static/media/bank.69bc3d56.PNG";